import type { BoltHole, CornerBoltHoles, PlainCylinderHole, PlainLocksetHole } from 'metalworks-domain'

import { DistanceDimensionSlider } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

import { AnchorPointsToggle } from '../AnchorPointsToggle'
import { GenericDistancePropertyContainerItem } from './GenericDistancePropertyPage'

interface Props {
  id: BoltHole['id'] | PlainCylinderHole['id'] | PlainLocksetHole['id'] | CornerBoltHoles['id']
  disableAnchorSwitching?: boolean
}

export const HolePropertyPage = (props: Props) => {
  const { id, disableAnchorSwitching } = props

  return (
    <PropertyContainer.Group spacing="large">
      <GenericDistancePropertyContainerItem id={id} />
      <PropertyContainer.Item title="Diameter">
        <DistanceDimensionSlider entityId={id} instanceName="diameter" />
      </PropertyContainer.Item>
      {disableAnchorSwitching !== true && <AnchorPointsToggle />}
    </PropertyContainer.Group>
  )
}
